import { useRunOnce } from './useRunOnce.js';
import { useClientLayoutEffect } from './useClientLayoutEffect.js';

const useFocusOnMount = (ref, args) => {
  useRunOnce(() => {
    ref.current?.focus();
  }, {
    condition: !!ref.current && args.condition,
    useEffectFn: useClientLayoutEffect
  });
};

export { useFocusOnMount };
//# sourceMappingURL=useFocusOnMount.js.map
